/**
 * @author 彭乐政
 * @description 存储各种状态
 * @date 2019/6/20 15:34
 * @version 1.0.0
 */
import TYPES from '../types.js'

export const boxState = {
    isLoading: false,
    isLmDetailLoading: false,
    searchCancel: null,
    errcount: 0
}

export const boxStateGetters = {
    isLoading: state => state.boxState.isLoading,
    isLmDetailLoading: state => state.boxState.isLmDetailLoading
}

export const boxStateMutations = {
    [TYPES.SET_ISLOADING](state) {
        state.boxState.isLoading = true
    },
    [TYPES.SET_ERRCOUNT](state,data) {
        state.boxState.errcount = data
    },
    [TYPES.CANCEL_ERRCOUNT](state) {
        state.boxState.errcount = 0
    },
    [TYPES.CANCEL_ISLOADING](state) {
        state.boxState.isLoading = false
    },
    [TYPES.SET_LmDetail_ISLOADING](state) {
        state.boxState.isLmDetailLoading = true
    },
    [TYPES.CANCEL_LmDetail_ISLOADING](state) {
        state.boxState.isLmDetailLoading = false
    },
    [TYPES.SET_SEARCH_CANCEL](state, cancel) {
        // 旧的取消有值，新传入了一个取消
        if (state.boxState.searchCancel) {
            state.boxState.searchCancel()
        }
        state.boxState.searchCancel = cancel || null
    },
}



// WEBPACK FOOTER //
// ./store/modules/m-get-loadstate.js